import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCallQueueFilters } from '@rsos/reduxDataStore/src/features/selectors/callQueueSelector';
import { updateUserAttributes } from '@rsos/sinatra';
import { captureException } from '@rsos/utils/sentry';
import { notifyError } from '@rsos/utils/toastUtils';
import useIsIRP from '@rsos/utils/useIsIRP';
import useCallTakerMode from '../../../../hooks/useCallTakerMode';
import useCallTakerModePerms from '../../../../hooks/useCallTakerModePerms';
import { ctmDisableErrorMsg } from '../../../CallTakerMode/constants';
import {
  trackCTMIconClicked,
  trackCTMEnabled,
} from '../../../CallTakerMode/ctmTracking';

const useActionBarCallTakerMode = () => {
  const dispatch = useDispatch();

  const { irpVersion } = useIsIRP();

  const application = useSelector(
    state => state.sinatra.user.currentRole?.application,
  );

  const user = useSelector(state => state.sinatra.user);

  useCallTakerMode();

  const hasCallTakerModeAccess = useCallTakerModePerms();

  const { toggleSetCallFilter } = useCallQueueFilters();

  const callTakerModeSettings =
    user.profile?.attributes?.[application]?.call_taker_mode_settings;

  const [isCallTakerModeModalOpen, setIsCallTakerModeModalOpen] =
    useState(false);

  const handleCallTakerModeClick = async () => {
    const positionID = callTakerModeSettings?.workstation_position || null;

    if (callTakerModeSettings?.is_enabled) {
      const data = {
        call_taker_mode_settings: {
          ...callTakerModeSettings,
          is_enabled: false,
        },
      };

      try {
        await dispatch(updateUserAttributes(application, data));

        toggleSetCallFilter('seatPosition', false);

        trackCTMEnabled(false, positionID, irpVersion);
      } catch (error) {
        notifyError(ctmDisableErrorMsg);

        captureException(error);
      }
    } else {
      setIsCallTakerModeModalOpen(true);

      trackCTMIconClicked(positionID, irpVersion);
    }
  };

  return {
    callTakerModeSettings,
    handleCallTakerModeClick,
    hasCallTakerModeAccess,
    isCallTakerModeModalOpen,
    setIsCallTakerModeModalOpen,
  };
};

export default useActionBarCallTakerMode;
